import { Inject, Injectable } from '@angular/core';

import { SESSION_STORAGE } from '~/auth/auth.module';
import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { ActivityDataInterface } from '~/messaging/interfaces/activity-data';
import { MessagingUserInterface } from '~/messaging/interfaces/user.interface';
import { BookingItemsGroupByUserIdInterface } from '~/organizer/shared/services/activity/interfaces/booking-items-group-by-user-id.interface';

import { ACTIVITY_STORAGE_KEY } from './talk.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  private readonly RECIPIENT_STORAGE_KEY = 'talkjs-recipient';
  public readonly isRecipientUpdated = new BehaviorSubject<boolean>(false);
  public recipientUpdated$ = this.isRecipientUpdated.asObservable();

  constructor(@Inject(SESSION_STORAGE) private readonly storage: Storage) {}

  // Build activity Data
  public buildActivityData(
    activity: Activity,
    timeslot?: Timeslot
  ): ActivityDataInterface {
    return {
      sku: activity.sku,
      name: activity.name,
      type: activity.type,
      photoUrl: activity.picture || null,
      timeslotIdentifier: timeslot?.identifier,
      timeslotStartDate: timeslot?.startDate,
    };
  }

  // factory methods

  public buildRecipientFromBookingItemsGroupByUserId(
    payload: BookingItemsGroupByUserIdInterface
  ): MessagingUserInterface {
    return {
      identifier: payload.userId,
      name: payload.bookingItems?.[0]?.attendees?.[0]?.name,
    };
  }

  // usage methods

  public getRecipient(): MessagingUserInterface {
    return JSON.parse(this.storage.getItem(this.RECIPIENT_STORAGE_KEY));
  }

  public removeActivityData(): void {
    this.storage.removeItem(ACTIVITY_STORAGE_KEY);
  }

  public removeRecipient(): void {
    this.storage.removeItem(this.RECIPIENT_STORAGE_KEY);
  }

  public storeActivityData(activityData: ActivityDataInterface): void {
    this.storage.setItem(ACTIVITY_STORAGE_KEY, JSON.stringify(activityData));
  }

  public storeRecipient(recipient: MessagingUserInterface): void {
    this.storage.setItem(this.RECIPIENT_STORAGE_KEY, JSON.stringify(recipient));
  }
}
